export default __webpack_public_path__ + "static/Poppins-Regular-1c701c9a6b587802e3d0211e89c52f4a.ttf";